import {consoleLogger, ReelConstants, ReelsetMatrix} from '@gongxigames/framework/slot';
import {GameCheatModule} from 'src/gameCheatPage/GameCheatModule';
import {addRowContainer, reelsABC} from 'src/gameCheatPage/ReelSetMatrixTemplates';
import {GameLogic} from 'src/server/GameLogic';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';
import {TotalBet} from 'com/gongxigames/math/core/game/TotalBet';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {WolfHavenEngine} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenEngine';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {WolfHavenFreeSpinEngine} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenFreeSpinEngine';
import {ReelSet} from 'com/gongxigames/math/core/game/ReelSet';

export class GameReelsetMatrix extends ReelsetMatrix {
    public static readonly ROW_POSITION_IN_CLASS_LIST: number = 18;
    public static readonly REEL_POSITION_IN_CLASS_LIST: number = 12;
    public static readonly REEL_POSITION_IN_SELECT_FIELD: number = 9;
    public static readonly ROWS_TO_REMOVER_ON_INIT: number[] = [3, 4];
    public static readonly MAX_ROWS_AMOUNT: number = 4;
    public static readonly MIN_ROWS_AMOUNT: number = 2;
    protected _openedRows: number[] = [2, 2, 2, 2, 2];
    protected _categoryIndex = 0;
    protected _positionsFound: number[] = [];
    protected _everyReelWeight: number[] = [];
    protected _reelsABC: number[] = [];
    protected _featureStopPosition: number[] = [];
    protected _spin?: WolfHavenSpin;
    protected _totalBet?: TotalBet;
    protected _input: HTMLInputElement;
    protected _noRowElement!: NodeListOf<Element>;
    protected _addRowIMG!: NodeListOf<Element>;
    protected _reelsABCSelect: any;
    protected _selectedABCIndexes: number[] = [-1, -1, -1, -1, -1];
    protected _currentStopPositions: number[] = [];
    protected _wolfReels: number[][] = [];
    protected _gameSingleReels: ReelSet = WolfHaven.BG_SINGLE_REEL_SET_$LI$();
    protected _gameDoubleReels: ReelSet = WolfHaven.BG_DOUBLE_REEL_SET_$LI$();
    protected onClickListener: Function;
    protected onAddRowClickListener: Function;

    constructor(cheat: GameCheatModule) {
        super(cheat);
        this._input = document.querySelector('#stopPositions input') as HTMLInputElement;
        this.createRowField();
        this.onClickListener = this.initMatrixSymbols.bind(this);
        this.addMatrixSymbolListener();
        this.removeMatrixSymbolListener();
        this.onAddRowClickListener = this.onAddRow.bind(this);
        this.addRowListener();
        this.createReelsABCSelectField();
    }

    public getReelStrips(): void {
        this._reelstrips.length = 0;

        if (this._logic.nextAction === Action.PICK) {
            return;
        }
        this._logic.getNextReelSet().getReels().forEach(strip => this._reelstrips.push(strip.getSymbols()));

        if (this._logic.previousAction !== this._logic.nextAction) {
            this.resetFilter();
        }
    }

    protected createReelsABCSelectField(): void {
        document.getElementById('realReelset')!.insertAdjacentHTML('afterend', reelsABC);
        this._reelsABCSelect = document.getElementById('reelsABC') as any;
        this._reelsABCSelect.onchange = (e: any) => this.setReelsABCselectedValues(e);
    }

    protected setReelsABCselectedValues(e: any): void {
        const reelNumber = Number(e.target.id.charAt(GameReelsetMatrix.REEL_POSITION_IN_SELECT_FIELD));

        this._selectedABCIndexes[reelNumber] = e.target.selectedIndex - 1;
    }

    protected resetReelsABCSelectedValues(): void {
        this._selectedABCIndexes = [-1, -1, -1, -1, -1];
        const selectFields = document.querySelectorAll('.reelsABCSelect') as unknown as any[];

        selectFields.forEach(elem => elem.selectedIndex = 0);
    }

    protected initReelsetMatrix(): void {
        const reelset = document.getElementById('realReelset')!;
        const reelsAmount = ReelConstants.REELS_AMOUNT;
        const symbolsAmount = ReelConstants.ROW_AMOUNT + 2;

        this.getReelStrips();
        this.updatePossibleImagesOnReels();
        reelset.className = `reels-${reelsAmount}`;
        for (let i = 0; i < reelsAmount; i++) {
            const reel = document.createElement('div');

            this._reels.push(reel);
            reel.className = `reel reel${i}`;
            for (let j = 0; j < symbolsAmount; j++) {
                this.addSymbolToMatrix(i, j);
            }
            reelset.appendChild(reel);
        }
        this.initMatrixButtons();
        this.initFilterEvents();
    }

    protected addRowListener(): void {
        const addRowSymbols = document.querySelectorAll('#addRow .picked') as any;

        for (const symbol of addRowSymbols) {
            symbol.addEventListener('click', this.onAddRowClickListener);
        }
    }

    protected addMatrixSymbolListener(reelNumber?: number, rowNumber?: number): void {
        const symbols = document.querySelectorAll('#realReelset .symbol') as any;

        for (const symbol of symbols) {
            const row = this.getRowFromElement(symbol);
            const reel = this.getReelFromElement(symbol);

            if (reelNumber === reel && row === rowNumber
                || reelNumber === undefined && GameReelsetMatrix.ROWS_TO_REMOVER_ON_INIT.indexOf(row) === -1) {
                symbol.classList.remove('disabled');
                symbol.addEventListener('click', this.onClickListener);
            }
        }
    }

    protected getRowFromElement(symbol: any): number {
        return Number(symbol.classList.value.charAt(GameReelsetMatrix.ROW_POSITION_IN_CLASS_LIST));
    }

    protected getReelFromElement(symbol: any): number {
        return Number(symbol.classList.value.charAt(GameReelsetMatrix.REEL_POSITION_IN_CLASS_LIST));
    }

    protected removeMatrixSymbolListener(reelNumber?: number): void {
        const symbols = document.querySelectorAll('#realReelset .symbol') as any;

        for (const symbol of symbols) {
            const row = this.getRowFromElement(symbol);
            const reel = this.getReelFromElement(symbol);

            if ((reelNumber === undefined || reel === reelNumber) && GameReelsetMatrix.ROWS_TO_REMOVER_ON_INIT.indexOf(row) !== -1) {
                symbol.classList.add('disabled');
                symbol.removeEventListener('click', this.onClickListener);
                this._openedRows[reelNumber!] = GameReelsetMatrix.MIN_ROWS_AMOUNT;
            }
        }
    }

    protected initMatrixSymbols(e?: any): void {
        let imgSymbolData;

        if (e.target.parentElement.classList[2]) {
            imgSymbolData = this.getImgSymbolData(e.target);
        } else {
            return;
        }

        if (e.target.nodeName === 'DIV') {
            e.target.classList.remove('picked');
            e.target.nextElementSibling.classList.add('picked');
            this.setNextImageSymbol(imgSymbolData);
        } else {
            if (this.isLastImageSymbol(imgSymbolData)) {
                this.resetSymbol(e);
            } else {
                this.setNextImageSymbol(imgSymbolData, false);
            }
        }
        e.target.oncontextmenu = (e: any) => {
            this.resetSymbol(e);
        };
    }

    protected createRowField(): void {
        document.getElementById('realReelset')!.insertAdjacentHTML('afterend', addRowContainer);
        this._addRowIMG = document.querySelectorAll('#addRow .symbol img');
        this._noRowElement = document.querySelectorAll('#addRow .symbol .picked');
    }

    protected onAddRow(e: any): void {
        const reelIndex = Number(e.target.parentElement.classList[1].substr(-1));

        this._openedRows[reelIndex]++;
        this._openedRows[reelIndex] > GameReelsetMatrix.MAX_ROWS_AMOUNT ?
            this.removeMatrixSymbolListener(reelIndex) : this.addMatrixSymbolListener(reelIndex, this._openedRows[reelIndex]);
    }

    protected isMatrixChosen(): boolean {
        return this._featureStopPosition.length > 5;
    }

    protected updatePossibleImagesOnReels(): void {
        this._reelstrips.forEach((strip, reelIndex) => {
            const possibleImagesOnReel: number[] = [];

            this._possibleImagesOnReels[reelIndex] = [];
            strip.forEach(symbol => possibleImagesOnReel.indexOf(symbol) === -1 && possibleImagesOnReel.push(symbol));
            for (let rowIndex = 0; rowIndex < ReelConstants.ROW_AMOUNT + 2; rowIndex++) {
                this._possibleImagesOnReels[reelIndex][rowIndex] = this.sortArray(possibleImagesOnReel);
            }
        });
    }

    protected setApplyBtn(): void {
        document.getElementById('applyButton')!.onclick = () => {
            if (this.isValueInputed()) {
                this.checkAndSetUserStopPositions(this._stopPositions);

                return;
            }
            const errorContainer = document.getElementById('errorContainer')!;

            if (errorContainer.classList.contains('show')) {
                return;
            }

            if (this.isMatrixChosen() && this._currentStopPositions.length > 0) {
                return;
            }

            if (!this.isMatrixChosen()) {
                this.setFeatures();
                this.updateTotalBet();

                if (errorContainer.classList.contains('show')) {
                    return;
                }
                this.updateReels();
                this.createSpinData();
                this.updateReelStrips();
                this.updatePossibleImagesOnReels();
            } else {
                this._currentStopPositions = [...this._stopPositions];
                this.updateInnerHTML(this._featureStopPosition.concat(this._currentStopPositions));
                this.isNextActionSpin() && this.setFilter(this._featureStopPosition.concat(this._currentStopPositions));
            }
        };
    }

    protected updateTotalBet(): void {
        this._totalBet = (this._logic as GameLogic).getClientSession().getTotalBet();
    }

    protected updateReels(): void {
        if (this.isFreeGames()) {
            const fgType = this.getFreeGamesType();

            this._gameSingleReels = fgType === 0 ?
                WolfHaven.FG_SINGLE_REEL_SET_0_$LI$() : fgType === 1 ?
                    WolfHaven.FG_SINGLE_REEL_SET_1_$LI$() : WolfHaven.FG_SINGLE_REEL_SET_2_$LI$();
            this._gameDoubleReels = fgType === 0 ?
                WolfHaven.FG_DOUBLE_REEL_SET_0_$LI$() : fgType === 1 ?
                    WolfHaven.FG_DOUBLE_REEL_SET_1_$LI$() : WolfHaven.FG_DOUBLE_REEL_SET_2_$LI$();
        }
        for (let i = 0; i < ReelConstants.REELS_AMOUNT; i++) {
            this._wolfReels[i] = this._reelsABC[i] === 1 ?
                this._gameDoubleReels.get(i).getSymbols() : this._gameSingleReels.get(i).getSymbols();
        }
    }

    protected createSpinData(): void {
        this._spin = new WolfHavenSpin(this._totalBet!, this.getCurrentAction(), WolfHaven.REEL_CAT_STEP1_$LI$()[5][this._categoryIndex], this.getFinalDimension(), this._wolfReels);
    }

    protected getCurrentAction(): number {
        return this.isFreeGames() ? Action.FREESPIN : Action.SPIN;
    }

    protected getFinalDimension(): number[] {
        const finalDimension: number[] = [];

        this._openedRows.forEach(rowsAmount => finalDimension.push(rowsAmount + 1));

        return finalDimension;
    }

    protected setFeatures(): void {
        this.getDimensionForEachReel();
        this.addWeightForCategory();
        this.addDimensionWeight();
    }

    public updateReelStrips(): void {
        this._reelstrips.length = 0;
        const reelSet = this.isFreeGames() ? WolfHavenFreeSpinEngine.createBonusReelSet(this._spin!)
            : WolfHavenEngine.createMainGameReelSet(this._spin!);

        reelSet.getReels().forEach(strip => this._reelstrips.push(strip.getSymbols()));
    }

    protected addDimensionWeight(): void {
        this._everyReelWeight.forEach(dimensionWeight => this._featureStopPosition.push(dimensionWeight));
    }

    protected getDimensionForEachReel(): void {
        for (let i = 0; i < ReelConstants.REELS_AMOUNT; i++) {
            if (this.checkWhatReelCategoryMatch(i)) {
                this._positionsFound[i] = this._categoryIndex;
            } else {
                this._positionsFound = [];
                this._categoryIndex++;

                if (this._categoryIndex > 242) {
                    this._categoryIndex = 0;
                    this.handleImpossibleCombination(true);

                    return;
                } else {
                    this.handleImpossibleCombination(false);
                }

                if (WolfHaven.REEL_CAT_STEP1[this.isFreeGames() ? this.getFreeGamesType() + 7 : 6][this._categoryIndex] === 0) {
                    this._categoryIndex++;
                }
                this._everyReelWeight = [];

                return this.getDimensionForEachReel();
            }
        }
    }

    protected handleImpossibleCombination(showError: boolean): void {
        const errorContainer = document.getElementById('errorContainer')!;
        const applyBtn = document.getElementById('applyButton')!;

        if (showError) {
            errorContainer.classList.add('show');
            applyBtn.classList.add('disabled');
        } else {
            applyBtn.classList.remove('disabled');
            errorContainer.classList.remove('show');
        }
    }

    protected checkWhatReelCategoryMatch(reelIndex: number): boolean {
        const input: number = WolfHaven.REEL_CAT_STEP1_$LI$()[reelIndex][this._categoryIndex];
        const category = input === 0 ?
            WolfHaven.REEL_CAT_STEP2_0_$LI$() : input === 1 ?
                WolfHaven.REEL_CAT_STEP2_1_$LI$() : WolfHaven.REEL_CAT_STEP2_2_$LI$();
        const rowsAmount = this._openedRows[reelIndex] + 1;

        if (category[1].indexOf(rowsAmount) !== -1) {
            this.updateDimensionWeightData(rowsAmount, reelIndex, category);
            this._reelsABC[reelIndex] = this.updateReelsABCData(category, this._everyReelWeight[reelIndex])!;

            if (this._selectedABCIndexes[reelIndex] === -1) {
                this._selectedABCIndexes[reelIndex] = Math.floor(Math.random() * 2);
            }

            if (this._reelsABC[reelIndex] === this._selectedABCIndexes[reelIndex]) {
                return true;
            }

            return false;
        }

        return false;
    }

    protected updateDimensionWeightData(rowsAmount: number, reelIndex: number, category: number[][]): void {
        let weight = -1;

        for (let i = 0; i <= category[1].indexOf(rowsAmount); i++) {
            weight += category[2][i];
        }
        this._everyReelWeight[reelIndex] = weight;
    }

    protected updateReelsABCData(category: number[][], weight: number): number | undefined {
        let reelABCWeight = -1;

        for (let i = 0; i <= category[2].length; i++) {
            reelABCWeight += category[2][i];

            if (weight <= reelABCWeight) {
                return category[0][i];
            }
        }
    }

    protected addWeightForCategory(): void {
        let weight = 0;

        for (let i = 0; i < this._categoryIndex; i++) {
            weight += this.isFreeGames() ? WolfHaven.REEL_CAT_STEP1[this.getFreeGamesType() + 7][i] : WolfHaven.REEL_CAT_STEP1[6][i];
        }
        this._featureStopPosition.unshift(weight);
    }

    protected checkAndSetUserStopPositions(stopPositions: number[]): void {
        const userStopPositions = this._input.value;

        this._input.classList.remove('error');

        if (userStopPositions) {
            const stopPosArr = userStopPositions.split(',').map(pos => isNaN(parseFloat(pos)) ? -1 : parseFloat(pos));

            if (this.isAppropriatePositions(stopPosArr)) {
                this.resetMatrix();
                this.resetReelSetMatrixData();
                this.initStopPositions();
                stopPosArr.forEach((pos, index) => stopPositions[index] = pos);
                this.updateInnerHTML(stopPosArr);

                if (this.isNextActionSpin()) {
                    this.setFilter(stopPosArr);
                }
            } else {
                this._input.classList.add('error');
            }
        }
    }

    protected isAppropriatePositions(stopPosArr: number[]): boolean {
        const reelsStopPositions = new Array(5);
        const reelStopPositionsStartIndex = 7;
        let isCorrectPositions = true;

        stopPosArr.forEach((stopPos, index) => {
            if (index >= reelStopPositionsStartIndex && index <= stopPosArr.length) {
                reelsStopPositions.push(stopPos);
            }
        });
        reelsStopPositions.forEach((stopPos, index) => {
            if (this._reelstrips[index] && stopPos >= this._reelstrips[index].length || stopPos < -1) {
                isCorrectPositions = false;
            }
        });

        return isCorrectPositions;
    }

    protected updateInnerHTML(stopPosArr?: number[]): void {
        this._filter.innerHTML = '';
        this._filter.innerHTML += `<p>Stop positions: ${stopPosArr ? stopPosArr : this._currentStopPositions}</p>`;
        consoleLogger.log(`ReelSetMatrix stop positions: ${stopPosArr ? stopPosArr.join(',') : this._currentStopPositions.join(',')}`);
    }

    protected isValueInputed(): boolean {
        return !!this._input.value;
    }

    protected isFreeGames(): boolean {
        const freeGamesBonus = (this._logic as GameLogic).getFreeGames();

        return freeGamesBonus !== null && !freeGamesBonus.isFinished();
    }

    protected getFreeGamesType(): number {
        const freeGamesBonus = (this._logic as GameLogic).getFreeGames();

        return freeGamesBonus.getFreeGameType();
    }

    protected resetFilter(): void {
        super.resetFilter();
        this.resetReelSetMatrixData();
    }

    protected resetReelSetMatrixData(): void {
        const symbols = document.querySelectorAll('#realReelset .symbol') as any;
        const errorContainer = document.getElementById('errorContainer')!;

        symbols && this.removeMatrixSymbolListener();
        this._reelsABCSelect && this.resetReelsABCSelectedValues();
        this._openedRows = [2, 2, 2, 2, 2];
        this._positionsFound = [];
        this._categoryIndex = 0;
        this._everyReelWeight = [];
        this._featureStopPosition = [];
        this._currentStopPositions = [];
        this._spin = undefined;
        this._totalBet = undefined;
        this._wolfReels = [];
        this._gameSingleReels = WolfHaven.BG_SINGLE_REEL_SET_$LI$();
        this._gameDoubleReels = WolfHaven.BG_DOUBLE_REEL_SET_$LI$();
        errorContainer && this.handleImpossibleCombination(false);
    }
}
